import { css } from '@emotion/react';
import { FallbackProps } from 'react-error-boundary';
import { useSetRecoilState } from 'recoil';

import Button from '@components/Common/Button';

import {
  accessTokenStorage,
  expirationDateStorage,
} from '@storage/authStorage';

import { palette } from '@styles/theme';

import { auth } from '@constants/state';

import { getErrorMessage } from '@apis/api';

const ErrorFallback = ({ error, resetErrorBoundary }: FallbackProps) => {
  const { status } = error.response;
  const { title, content } = getErrorMessage(status);
  const isNotAuthorized = status === 401 || status === 403;
  const buttonMessage = isNotAuthorized ? '로그인 하러가기' : '다시 시도';
  const setAuth = useSetRecoilState(auth);

  const handleOnClick = () => {
    if (isNotAuthorized) {
      setAuth({
        isLogin: false,
        name: '',
        email: '',
        role: undefined,
        company: '',
        companyId: undefined,
      });
      accessTokenStorage.clear();
      expirationDateStorage.clear();
      window.location.reload();
    } else {
      resetErrorBoundary();
    }
  };

  return (
    <div css={container}>
      <p css={[text, titles]}>{title}</p>
      <p css={text}>{content}</p>
      <Button
        label={buttonMessage}
        theme="secondary"
        handleClick={handleOnClick}
      />
    </div>
  );
};

export default ErrorFallback;

const container = css`
  width: 100%;
  height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  justify-content: center;
  button {
    background-color: ${palette.primaryColor};
    &:hover,
    &:active {
      background-color: ${palette.primaryColor};
      opacity: 0.8;
    }
  }
`;

const text = css`
  font-size: 14px;
`;

const titles = css`
  font-size: 20px;
  font-weight: 700;
`;
